export default __webpack_public_path__ + "static/compareItemImg1-88520bc85e13c3c754dabbe8a41538c9.webp";